
import React, { memo, useEffect, useState } from 'react'

import { GetThemeColorFromStorage } from '../../../redux/api/themeColor'
import { Box } from '@mui/material'

function Header({ themeStorage }) {
	const [theme, setTheme] = useState(themeStorage)

	const images = theme?.images?.internalPages

	useEffect(() => {
		setTheme(GetThemeColorFromStorage)
	}, [])


	return (
		<Box
			sx={{
				backgroundImage: `url(${images?.menuBackground?.url || themeStorage?.images?.internalPages?.menuBackground?.url})`,
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				height: '130px',
				justifyContent: 'center',
				width: '100%',
			}}
		>
			<Box sx={{ maxWidth: '1138px', width: '100%', margin: 'auto', pt: '10px' }}>
				<Box
					component="img"
					width="180px"
					src={images?.menuLogo?.url || themeStorage?.images?.internalPages?.menuLogo?.url}
					alt={`${images?.menuLogo?.filename || themeStorage?.images?.internalPages?.menuLogo?.filename}`}
				/>
			</Box>
		</Box>
	)
}

export default memo(Header)
